import { ApiResponse } from "@/types/api";
import { message } from "antd";
import request from "@/services/request";

// 手机号登录
export async function requestLogin(account: string, pass: string) {
  const res = (await request.post("/api/v1/login_phone", {
    oauth_type: "phone",
    account,
    pass,
  })) as ApiResponse;
  if (!res.success) {
    message.error(res.code_msg);
    return res;
  }
  return res;
}

// 获取验证码
export async function requestSmsCode(account: string) {
  const res = (await request.get("/api/v1/login/phone/code", {
    params: {
      phone: account,
    },
  })) as ApiResponse;
  if (!res.success) {
    message.error(res.code_msg);
    return res;
  }
  return res;
}

// 查询用户资料
export async function requestUserInfo(uid: string) {
  const res = (await request.get("/api/v1/userinfo/get", {
    params: { uid },
  })) as ApiResponse;
  if (!res.success) {
    message.error(res.code_msg);
    return res;
  }
  return res;
}